import StringManager from '../StringManager';
export const strings = new StringManager();
export default strings;
